export const useHelpers = () => {
    
    const customHelper = () => {
        console.log('HOLA MUNDO')
    }

    const getCurrentDate = () => {
        const today = new Date(); // Crea un objeto de fecha con la fecha actual
        const year = today.getFullYear(); // Obtiene el año
        const month = today.getMonth() + 1; // Obtiene el mes (getMonth() devuelve un índice basado en cero, por lo que se suma 1)
        const day = today.getDate(); // Obtiene el día del mes
    
        // Formatea la fecha en 'YYYY-MM-DD', asegurándote de agregar un cero delante de meses y días menores a 10
        return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
    }

    const isDayThirtyOne = (date) => {
        // Dividimos la fecha en partes usando el separador '-'
        const [year, month, day] = date.split('-');
    
        // Convertimos el día a un número
        const dayNumber = parseInt(day, 10);
    
        // Verificamos si el día es 31
        return dayNumber === 31;
    }

    const convertToFloat = (formattedNumber) => {
        const cleanedValue = formattedNumber.replace(/,/g, '');
        const floatValue = parseFloat(cleanedValue);
        return isNaN(floatValue) ? 0 : floatValue; // Retorna 0 si no es un número válido
    };

    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });
    
    return Object.freeze({
        customHelper,
        getCurrentDate,
        isDayThirtyOne,
        convertToFloat,
        numberFormatter
    })
}